import axios from 'axios';
import Config from 'Config';

import { createSignedRequest } from 'utils/createSignedRequest';

export const getFileUploadSignedUrl = async ({ fileName, contentType, filePath, projectId }) => {
  const apiPath = `files/upload-signed-url/upload-file`;

  const data = {
    fileName,
    contentType,
    filePath,
  };

  const request = {
    // url: `http://localhost:3001/${apiPath}`,
    url: `https://${process.env.REACT_APP_WORK_CALENDAR_API_URL}/${apiPath}`,
    host: process.env.REACT_APP_WORK_CALENDAR_API_URL,
    path: apiPath,
    method: 'POST',
    region: Config.AWS_REGION,
    service: 'execute-api',
    body: JSON.stringify(data),
    data: data,
    headers: {
      'Content-Type': 'application/json',
    },
  };

  const signedRequest = await createSignedRequest(request);

  const response = await axios(signedRequest);

  return response.data;
};
